import { atom } from "recoil";
import AsyncLocalStorage from "../utils/AsyncLocalStorage";

export type DeliverySettingType = {
  type: string;
  name: string;
  mode: number;
  app_call_delay: number;
};

export const deliveryServiceList: any[] = [
  { type: "barogo", name: "바로고", mode: 0 }, // mode 0: 매크로 1: API 연동
  { type: "logiall", name: "생각대로", mode: -1 },
  { type: "none", name: "해당없음", mode: -1 },
];

export const deliverySettingDefault = {
  type: "none",
  name: "해당없음",
  mode: -1,
  app_call_delay: 1000,
};

// export const initDeliverySetting = () => {
//   const deliverySetting = AsyncLocalStorage.getItem("deliverySetting");
//   //console.log('deliverySetting', deliverySetting);
//   if (!deliverySetting) {
//     AsyncLocalStorage.setItem(
//       "deliverySetting",
//       JSON.stringify(deliverySettingDefault)
//     );
//   } else if (deliverySetting && !deliverySetting.type) {
//     AsyncLocalStorage.setItem(
//       "deliverySetting",
//       JSON.stringify(deliverySettingDefault)
//     );
//   }
// };

export const deliverySettingState = atom<DeliverySettingType>({
  key: "deliverySetting",
  default: deliverySettingDefault,
  effects: [
    ({ setSelf, onSet }) => {
      const savedData = AsyncLocalStorage.getItem("deliverySetting");

      if (savedData) setSelf(savedData);

      onSet((newValue, _, isReset) => {
        isReset
          ? AsyncLocalStorage.removeItem("deliverySetting")
          : AsyncLocalStorage.setItem(
              "deliverySetting",
              JSON.stringify(newValue)
            );
      });
    },
  ],
});

Object.freeze(deliveryServiceList);
